const { appVersion } = require("../../../config.json");

const latest = require(`../v${appVersion}`);
module.exports = latest;
